/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCreds} from '../api'

 export const useQueryGetCreds = createReactQueryHook('getCreds', getCreds)
